import { config } from '../../../config';
import { getLogger } from '../../../services/logger';
import { request } from '../../../utils';

import { buildSvpQueryParams } from './buildSvpQueryParams';

const logger = getLogger('requestSVP');

const { svpApiHostname, svpApiAppName } = config;

export type SvpGetAssetsParams = {
  sort?: string;
  limit?: number;
  page?: number;
  filter?: { [k: string]: string };
  additional?: string;
  showAll?: boolean;
  before?: number;
  after?: number;
};

export type SvpSearchAssetsParams = {
  query?: string;
  sort?: string;
  limit?: number;
  page?: number;
  filter?: { [k: string]: string };
  additional?: string;
  before?: number;
  after?: number;
};

export type SvpMostSeenParams = {
  limit?: number;
  page?: number;
  filter?: { [k: string]: string };
  additional?: string;
  interval?: 'hour' | 'day' | 'week' | 'month';
};

export type SvpFetchParams =
  SvpGetAssetsParams | SvpSearchAssetsParams | SvpMostSeenParams;

export async function requestSVP<T = never>({
  provider,
  path,
  params,
  signal,
}: {
  provider: 'vgtv' | 'ab' | 'brandstudio';
  path: string;
  params?: SvpFetchParams;
  signal?: AbortSignal;
}) {
  const basePath = `${svpApiHostname}${provider}`;
  const queryParams = buildSvpQueryParams(params);
  const queryString = `?appName=${svpApiAppName}${queryParams}`;

  try {
    const response = await request<T>(`${basePath}${path}${queryString}`, {
      signal,
    });

    return await response.json();
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw error;
    }
    logger.error('SVP request failed', { provider, path, error });
    throw error;
  }
}
